/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModulePrimary_componentModule = {
    readonly messages: {
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePromoItem_promotion">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespPromoModulePrimary_componentModule";
};
export type HpRespPromoModulePrimary_componentModule$data = HpRespPromoModulePrimary_componentModule;
export type HpRespPromoModulePrimary_componentModule$key = {
    readonly " $data"?: HpRespPromoModulePrimary_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePrimary_componentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespPromoModulePrimary_componentModule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "PromoModuleMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PromoItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cmsId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpRespPromoModulePromoItem_promotion"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PromoModule",
  "abstractKey": null
};
(node as any).hash = '9a4d0b8bccb537e6e66f16db6b4cfc6d';
export default node;
